import { Component, HostBinding, Injector, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';

@Component({
    selector: 'fi-time-picker-popup',
    templateUrl: './time-picker-popup.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./time-picker-popup.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiTimePickerPopupComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiTimePickerPopupComponent,
        },
    ],
    standalone: false,
})
export class FiTimePickerPopupComponent extends ControlValueAccessorValidatorBase<Date> implements OnChanges {
    @Input() showMeridian: boolean = false;
    @Input() disabled: boolean = false;
    @Input() minTime;

    @HostBinding('class.DateTimeSelector')
    get isDateTimeSelector() {
        return true;
    }

    datePipe: DatePipe;

    constructor(private injector: Injector) {
        super(injector);
        this.datePipe = new DatePipe('en_US');
    }

    inputTime: string;
    timePickerModel;

    ngOnChanges(changes) {
        if (changes.ngModel) this.updateInputTime(this.ngModel);
    }

    testTime(time: string) {
        const timeRegex = this.showMeridian
            ? /^(0?[0-9]|1[0-2]):[0-5][0-9] ?[a|p]m$/i
            : /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        return timeRegex.test(time);
    }

    inputTimeChange() {
        const viewValue = this.inputTime;
        if (!viewValue) {
            this.updateModel(null);
            return;
        }
        if (this.testTime(viewValue)) {
            const date = new Date();
            const sp = viewValue.split(':');
            const apm = sp[1].match(/[a|p]m/i);
            if (apm) {
                sp[1] = sp[1].replace(/[a|p]m/i, '');
                if (apm[0].toLowerCase() == 'pm') sp[0] = (parseInt(sp[0]) + 12).toString();
            }
            date.setHours(parseInt(sp[0]) || 0, parseInt(sp[1]) || 0, 0);
            this.updateModel(date);
        }
    }

    updateInputTime(value: Date) {
        if (!value) {
            this.inputTime = '';
        } else {
            const timeFormat = this.showMeridian ? 'hh:mm a' : 'HH:mm';
            this.inputTime = this.datePipe.transform(value, timeFormat);
        }
        this.updateTimePickerModel(value);
    }

    updateTimePickerModel(value) {
        if (value) {
            this.timePickerModel = {
                hour: value.getHours(),
                minute: value.getMinutes(),
                second: 0,
            };
            return;
        }
        this.timePickerModel = null;
    }

    private updateModel(value) {
        this.ngModel = value;
        this.doPropagateChanges();
    }

    doValidate(control: AbstractControl): ValidationErrors {
        const validationResult: ValidationErrors = {
            time: this.inputTime && !this.testTime(this.inputTime),
        };
        return validationResult;
    }
}
